import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Frios.css";

import Navbar from "../../components/parts/navbar/Navbar";
import TopLinks from "../../components/parts/TopLinks/TopLinks";
import Menu from "../../components/parts/menu/Menu";
import Footer from "../../components/parts/footer/Footer";
import BTNtoTop from "../../components/parts/BTNtoTop/BTNtoTop";
import FriosBanners from "./friosBanners/FriosBanner";
import FriosNavigate from "./friosNavigate/FriosNavigate";
import FoodTitulos from "./friosTitulos/FriosTitulos";
import FriosProductsSection from "./friosProductsSection/FriosProductsSection";
import IntroParceiros from "../intro/parts/IntroParceiros/IntroParceiros";
import IntroTitulos from "../intro/parts/IntroTitulos/IntroTitulos";
import Section from "../../components/debug/Section";

export default function Frios() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const [titulos, setTitulos] = useState([]);
  const [loadingTitulos, setLoadingTitulos] = useState(true);

  // 🔹 Marcas
  const [marcas, setMarcas] = useState([]);
  const [loadingMarcas, setLoadingMarcas] = useState(true);

  // 🔹 Banners
  const [banners, setBanners] = useState([]);
  const [loadingBanners, setLoadingBanners] = useState(true);

  // 🔹 Carregar banners

  useEffect(() => {
    async function carregarBanners() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/home_media/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setBanners(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingBanners(false);
      }
    }

    carregarBanners();
  }, []);

  // 🔹 Carregar Marcas
  useEffect(() => {
    async function carregarMarcas() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/marcas/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );
        const data = await response.json();
        setMarcas(data);
      } catch (error) {
        console.error("Erro ao buscar produtos:", error);
      } finally {
        setLoadingMarcas(false);
      }
    }

    carregarMarcas();
  }, []);

  //Carregar Titulos
  useEffect(() => {
    async function carregarTitulos() {
      try {
        const response = await fetch(
          "https://app.eliandroalimentos.com.br/api/titulos/listar",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          }
        );

        const data = await response.json();
        setTitulos(data);
      } catch (error) {
        console.error("Erro ao buscar títulos:", error);
      } finally {
        setLoadingTitulos(false);
      }
    }

    carregarTitulos();
  }, []);

  function getFriosTitulo(localizacao) {
    const titulo = titulos.find((item) => item.localizacao === localizacao);

    return titulo?.descricao || null;
  }

  return (
    <>
      <Navbar />
      <TopLinks onOpenMenu={() => setMenuOpen(true)} />
      <Menu isOpen={menuOpen} onClose={() => setMenuOpen(false)} />

      <Section name="FriosBanners 1">
        <FriosBanners //Banner1
          banners={banners}
          ordem={1}
        />
      </Section>

      <Section name="FriosNavigate">
        <FriosNavigate //navegar categorias
        />
      </Section>

      <Section name="FriosBanners 2">
        <FriosBanners //Banner2
          banners={banners}
          ordem={2}
        />
      </Section>

      <div className="food-wrapper">
        <Section name="FriosTitulos 1">
          {getFriosTitulo("friostitulo01") && (
            <FoodTitulos title={getFriosTitulo("friostitulo01")}/>
          )}
        </Section>

        <Section name="FriosProductsSection 1">
          <FriosProductsSection localizacao="frios01"/>
        </Section>
      </div>

      {/* CONTEÚDO */}
      <div className="food-wrapper">
        <Section name="FriosTitulos 2">
          {getFriosTitulo("friostitulo02") && (
            <FoodTitulos title={getFriosTitulo("friostitulo02")}/>
          )}
        </Section>

        <Section name="FriosProductsSection 2">
          <FriosProductsSection localizacao="frios02"/>
        </Section>
      </div>

      <Section name="IntroTitulos">
        <IntroTitulos
          titulos={titulos}
          loading={loadingTitulos}
          localizacao="introtitulo"
          ordem={6}
        />
      </Section>

      <Section name="IntroParceiros">
        <IntroParceiros
          marcas={marcas}
          loading={loadingMarcas}
          localizacao="introparceiros02"
        />
      </Section>

      <div className="food-wrapper">
        <Section name="FriosTitulos 3">
          {getFriosTitulo("friostitulo03") && (
            <FoodTitulos title={getFriosTitulo("friostitulo03")} />
          )}
        </Section>

        <Section name="FriosProductsSection 3">
          <FriosProductsSection localizacao="frios03"/>
        </Section>
      </div>

      <div className="food-wrapper">
        <Section name="FriosTitulos 4">
          {getFriosTitulo("friostitulo04") && (
            <FoodTitulos title={getFriosTitulo("friostitulo04")} />
          )}
        </Section>

        <Section name="FriosProductsSection 4">
          <FriosProductsSection localizacao="frios04"/>
        </Section>
      </div>

      <Section name="FriosBanners 3">
        <FriosBanners //Banner3
          banners={banners}
          ordem={3}
        />
      </Section>

      <div className="food-wrapper">
        <Section name="FriosTitulos 5">
          {getFriosTitulo("friostitulo05") && (
            <FoodTitulos title={getFriosTitulo("friostitulo05")} />
          )}
        </Section>

        <Section name="FriosProductsSection 5">
          <FriosProductsSection localizacao="frios05"/>
        </Section>
      </div>

      <div className="food-wrapper">
        <Section name="FriosTitulos 6">
          {getFriosTitulo("friostitulo06") && (
            <FoodTitulos title={getFriosTitulo("friostitulo06")} />
          )}
        </Section>

        <Section name="FriosProductsSection 6">
          <FriosProductsSection localizacao="frios04"/>
        </Section>
      </div>

      <BTNtoTop />
      <Footer />
    </>
  );
}
